// src/components/Consultar.js
// Tela de CONSULTA — lista todos os produtos e permite busca por nome

import React, { useState, useEffect } from "react";
import { getProdutos } from "../services/api";

export default function Consultar({ onVoltar }) {
  // ── Estados ──────────────────────────────────────────────────────
  const [produtos, setProdutos]   = useState([]);   // lista completa
  const [busca, setBusca]         = useState("");    // filtro de busca
  const [loading, setLoading]     = useState(true);  // indicador de carregamento
  const [erro, setErro]           = useState(null);  // mensagem de erro

  // ── Efeito: carrega produtos ao montar o componente ──────────────
  useEffect(() => {
    carregarProdutos();
  }, []); // [] = executa apenas uma vez (componentDidMount)

  async function carregarProdutos() {
    try {
      setLoading(true);
      setErro(null);
      const data = await getProdutos(); // chama a API
      setProdutos(data);
    } catch (e) {
      setErro("Erro ao carregar produtos. Verifique se o servidor está rodando.");
    } finally {
      setLoading(false);
    }
  }

  // ── Filtragem local (sem nova chamada à API) ──────────────────────
  const produtosFiltrados = produtos.filter((p) =>
    p.nome.toLowerCase().includes(busca.toLowerCase())
  );

  // ── Formatação de moeda ──────────────────────────────────────────
  const formatarPreco = (valor) =>
    new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(valor);

  // ── Render ───────────────────────────────────────────────────────
  return (
    <div className="tela">
      <div className="tela-header">
        <h2>🔍 Consultar Produtos</h2>
        <p>Visualize e pesquise todos os produtos cadastrados</p>
      </div>

      {/* Campo de busca */}
      <div className="busca-container">
        <input
          type="text"
          placeholder="🔎 Buscar por nome..."
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
          className="input-busca"
        />
        <button onClick={carregarProdutos} className="btn btn-secondary">
          🔄 Atualizar
        </button>
      </div>

      {/* Estado de carregamento */}
      {loading && <div className="status-msg loading">⏳ Carregando produtos...</div>}

      {/* Estado de erro */}
      {erro && <div className="status-msg erro">❌ {erro}</div>}

      {/* Tabela de resultados */}
      {!loading && !erro && (
        <>
          <div className="resultado-info">
            {produtosFiltrados.length} produto(s) encontrado(s)
          </div>
          <div className="tabela-container">
            <table className="tabela">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>Preço</th>
                  <th>Estoque</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {produtosFiltrados.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="sem-dados">
                      Nenhum produto encontrado
                    </td>
                  </tr>
                ) : (
                  produtosFiltrados.map((produto) => (
                    <tr key={produto.id}>
                      <td className="td-id">#{produto.id}</td>
                      <td className="td-nome">{produto.nome}</td>
                      <td className="td-preco">{formatarPreco(produto.preco)}</td>
                      <td className="td-estoque">{produto.estoque} un.</td>
                      <td>
                        <span className={`badge ${produto.estoque > 10 ? "badge-ok" : produto.estoque > 0 ? "badge-baixo" : "badge-zero"}`}>
                          {produto.estoque > 10 ? "✅ Normal" : produto.estoque > 0 ? "⚠️ Baixo" : "❌ Zerado"}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
